module.exports = __webpack_public_path__ + "static/media/about-left-patch.a8c86269.png";